import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Select } from '../../../components/form-fields/Select';
import Toggle from '../../../../components/common/toggleButton';

export interface JustifyContentProps {
  value: IJustifyContentProps;
  onChange: (_value: IJustifyContentProps) => void;
  title: string;
}
export const justifyContentProps = {
  justifyContent: {
    deviceType: 'desktop',
    justify: {
      desktop: 'justify-start',
      tablet: 'justify-start',
      mobile: 'justify-start',
    },
  },
};

export interface IJustifyContentProps {
  deviceType: string;
  justify: {
    mobile: string;
    tablet: string;
    desktop: string;
  };
}

export const JustifyOptions = [
  { label: 'center', value: 'justify-center' },
  { label: 'start', value: 'justify-start' },
  { label: 'end', value: 'justify-end' },
  { label: 'between', value: 'justify-between' },
  { label: 'around', value: 'justify-around' },
  { label: 'evenly', value: 'justify-evenly' },
];

const JustifyContent: React.FC<JustifyContentProps> = ({
  onChange,
  value,
  title,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={() => setIsOpen(!isOpen)}>
        <h3>{title}</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      {isOpen && (
        <div className="flex flex-col gap-4 mt-3  border border-gray-300 rounded p-2 w-full">
          <Toggle<IJustifyContentProps>
            value={value}
            onChange={newValue => onChange({ ...value, ...newValue })}
            heading={{ label: 'Device', value: 'device' }}
            options={[
              { label: 'Desktop', value: 'desktop' },
              { label: 'Tablet', value: 'tablet' },
              { label: 'Mobile', value: 'mobile' },
            ]}
            propName="deviceType"
          />
          <Select
            className="pagebuilder-theme"
            value={
              value.justify?.[value.deviceType as keyof typeof value.justify]
            }
            onChange={e =>
              onChange({
                ...value,
                justify: {
                  ...value.justify,
                  [value.deviceType]: e.target.value,
                },
              })
            }
            options={JustifyOptions}
            label="Justify Content"
          />
        </div>
      )}
    </div>
  );
};
export default JustifyContent;
